import React from 'react'


function Pricing() {
  return (
    <div>
        <p>pricing page na your mate?</p>
    </div>
  )
}

export default Pricing